<div class="wizard">	
	<div class="overlay" *ngIf="loading"></div>
	
	<div class='container' style="width: 100vw; padding: 5px; border-bottom: 1px solid #4472c4;">
		<div class='row'>
			<div class="col-xs-12" style="text-align: center">
				<a href="javascript:void(0)" (click)="goback()" class="backbutton navigation">&larr;</a>
				<img src="logo.png" width="150" />
				
			</div>
		</div>
	</div>
	
	<alert></alert>

	<div class="wrapper">
		<div class="container">
			<alert></alert>
			<div class="row vertical-align">
				<div style="min-width: 400px;" class="col-xs-6">
					<h2>Activate your GraphOn.com account.</h2>
					<p>This account has not been activated yet. Enter the activation key that was sent to you in e-mail to activate this account.</p>
					<form name="form" (ngSubmit)="f.form.valid && activate()" #f="ngForm" novalidate>
						<div class="form-group" [ngClass]="{ 'has-error': f.submitted && !key.valid }">
							<!-- <label for="key">Activation Key</label> -->
							<input type="text" class="form-control" name="key" [(ngModel)]="model.key" #key="ngModel" required placeholder="Activation Key" />
							<div *ngIf="f.submitted && !key.valid" class="help-block">Activation Key is required</div>
						</div>
						<div class="form-group">
							<button [disabled]="loading" class="btn btn-primary">Activate Account</button>&nbsp;
							<a [routerLink]="['/wizard/wizardLogin']" class="btn btn-link">Cancel</a>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>
